import { useState, useEffect, useRef } from "react";

/**
 * Custom hook to handle chat messages
 */
export const useChatMessages = () => {
  const [chatMessages, setChatMessages] = useState([]);
  const chatScrollRef = useRef(null);

  /**
   * Adds a message to the chat
   */
  const addMessage = (message) => {
    setChatMessages((prev) => [...prev, message]);
  };

  /**
   * Replaces the last thinking message with a new message
   */
  const replaceThinkingMessage = (newMessage) => {
    setChatMessages((prev) =>
      prev.filter((msg) => !msg.isThinking).concat(newMessage)
    );
  };

  /**
   * Auto-scroll to bottom when there are new messages
   */
  useEffect(() => {
    if (chatScrollRef.current) {
      chatScrollRef.current.scrollTop = chatScrollRef.current.scrollHeight;
    }
  }, [chatMessages]);

  return {
    chatMessages,
    setChatMessages,
    addMessage,
    replaceThinkingMessage,
    chatScrollRef,
  };
};
